// extracted by mini-css-extract-plugin
export default {"item":"breadcrumbs__item___xWpYC","container":"breadcrumbs__container___Dvry3","orangeHover":"breadcrumbs__orangeHover___gXBpZ","disabled":"breadcrumbs__disabled____yst1"};